export const getGrpcResponse = (response) => {
  if (response?.array) {
    return response?.array;
  } else if (response?.u) {
    return response?.u;
  }
  return null;
};
